var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('van-loading',{attrs:{"size":"24px","text-color":"#0094ff","color":"#0094ff","vertical":""}},[_vm._v("登录中...")])}
var staticRenderFns = []

export { render, staticRenderFns }